
import Macy from 'macy';

let macyInstance = Macy({
    container: '#macy-container',
    margin: 32,
    columns: 3,
    breakAt: {
        //1200: 4,
        940: 3,
        860: 2,
        520: 1,
    }
});
